module.exports = __webpack_public_path__ + "static/media/NASSIM-HARAMEIN-team-picture.b1190327.jpg";